import { render } from "./FirmDashboard.vue?vue&type=template&id=286260d2&scoped=true"
import script from "./FirmDashboard.vue?vue&type=script&lang=js"
export * from "./FirmDashboard.vue?vue&type=script&lang=js"

import "./FirmDashboard.vue?vue&type=style&index=0&id=286260d2&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286260d2"]])

export default __exports__